<template>
  <BasicModalWindow
    ref="modal_element"
    class="small-window folders-actions"
    :title="modal_title"
    :gtm="{
      module : 'folders',
      feature: 'folders_edit_modal',
      block  : 'modal_header',
      action : 'cancel'
    }"
  >
      <template #body>
        <div class="form">
            <fieldset>
                    <div class="control-group">
                        <div class="control">
                            <label for="new_folder_name">{{Language.say(('folders.new_name'))}}</label>
                            <input @keyup.enter="onEditFolder()" id="new_folder_name" type="text" v-focus="true" v-model="new_folder_name">
                        </div>
                    </div>
              </fieldset>
          </div>
      </template>
      <template #footer>
          <ActionButton
              @click="onEditFolder()"
              icon='fas fa-folder-open'
              class='main-action push-right'
              :disabled="!new_folder_name || new_folder_name === selected_folder.name"
              :loading="folders_controller.saving_state.saving[selected_folder.id]"
              text="folders.edit.rename"
              :gtm="{
                module : 'folders',
                feature: 'folders_edit_modal',
                block  : 'modal_footer',
                action : 'submit'
              }"
          />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import {defineProps, ref }  from 'vue';
  import BasicModalWindow     from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton         from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language             from '@/js/Shared/Language/Language.js';
  import FoldersController    from '@/js/Mailboxes/FoldersController';

  const props   = defineProps({
    selected_folder : {
      required: true,
    }
  })

  const folders_controller = FoldersController;
  const modal_element      = ref();
  const new_folder_name    = ref(props.selected_folder.name);
  const modal_title        = Language.say('folders.edit.title', [props.selected_folder.name]);

  const onEditFolder = async () => {
    let success  = await folders_controller.edit(props.selected_folder, new_folder_name.value);

    if (success) {
      modal_element.value.close();
    }
  }
</script>
